import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import useSelection from '../hooks/use-selection'
import useModelKey from '../hooks/use-model-key'

function WhenSelected (props) {
  const selection = useSelection()
  const modelKey = useModelKey()

  if (selection.isSelected(modelKey) === props.flip) {
    return null
  }

  return props.children
}

WhenSelected.defaultProps = {
  flip: false
}

WhenSelected.propTypes = {
  flip: PropTypes.bool
}

export default observer(WhenSelected)
